import React from 'react';
import InfoTooltip from '../InfoTooltip';

const RecruitmentBox = ({ finalTP, prevalence, sensitivity, specificity }) => {
  const baseline = finalTP / prevalence;
  const sampleSizeStep1 = Math.ceil(finalTP / (sensitivity * prevalence));
  const percentageChange = ((sampleSizeStep1 / baseline) * 100) - 100;

  const infoStyle = percentageChange > 0 ? { color: 'green' } : { color: 'red' };
  const iconName = percentageChange > 0 ? 'arrow-up' : 'arrow-down';

  return (
    <div className="p-3 card gradient2">
      <h4 className='d-flex'>Recruitment <InfoTooltip tooltipTextKey="tooltip_recruitment_box" color="white" /></h4>
      <div className="card-body">
        <div className="info" style={infoStyle}>
          <h5>{sampleSizeStep1.toLocaleString()}</h5>
          <h6>{percentageChange.toFixed(2)}% <i className={`fas fa-${iconName}`}></i></h6>
        </div>
      </div>
    </div>
  );
};

export default RecruitmentBox;
